import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { SyncEventsDocument } from './sync.generated';

export const useSyncEvents = (options: ApiOptions<typeof SyncEventsDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(SyncEventsDocument, {
    ...useNotifications(SyncEventsDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.events.sync_success'),
    }),

    ...options,
  });
};
